import { SpaceBetween } from '@amzn/awsui-components-core';

import { usePublicationMetadataViewModel } from './PublicationMetadataViewModel';

/**
 * Displays the publication metadata: Stage, Target audience, Current
 * visibility, and (once decided) the deciding Bar raiser.
 */
export default function PublicationMetadata() {
  const vm = usePublicationMetadataViewModel();

  return (
    <SpaceBetween size={'xxs'} direction="vertical">
      <div>
        <strong>Stage: </strong>
        <span>{vm.stageLabel}</span>
      </div>
      <div>
        <strong>Target audience: </strong>
        <span>{vm.audienceLabel}</span>
      </div>
      <div>
        <strong>Current visibility: </strong>
        <span>{vm.visibilityLabel}</span>
      </div>
      {vm.barRaiserAlias && (
        <div>
          <strong>Bar raiser: </strong>
          <span>{vm.barRaiserAlias}</span>
        </div>
      )}
      {vm.barRaiserReviewLabel && (
        <div>
          <strong>BR review status: </strong>
          <span>{vm.barRaiserReviewLabel}</span>
        </div>
      )}
    </SpaceBetween>
  );
}
